import styled from 'styled-components';
import { Colors } from '../../colors';
const getColor = ({ $appearance, $isOpen, theme }) => {
    var _a, _b;
    if ($appearance === 'primary') {
        return $isOpen ? Colors.GS1000 : ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorOnBackground) || Colors.GS1000;
    }
    if ($appearance === 'secondary') {
        return Colors.GS600;
    }
};
export const TooltipContainer = styled.div `
  color: ${getColor};
  cursor: pointer;

  &:hover {
    color: ${Colors.B500};
  }
`;
//# sourceMappingURL=styled.js.map